export default Object.freeze({
  LOGIN_POPUP: 'LOGIN_POPUP',
  PAGE_TITLE: 'PAGE_TITLE',
});
